'use client';

import { BiPlay } from 'react-icons/bi';
import React from 'react';
import { useModal } from '@/components/ModalContext/ModalContext';

export type LouiseWatchNowButtonColorType = 'blue' | 'gray' | 'black' | 'white';
export type WatchButtonCtaTargetType =
  | 'register'
  | 'login'
  | 'plans'
  | 'youtube'
  | 'roi-calculator'
  | 'discover-human-clone-link'
  | 'discover-chatbot-type'
  | 'discover-chatbot-ai'
  | 'discover-videobot'
  | 'discover-chatbot-text'
  | 'external'
  | 'other';

type props = {
  textColor: LouiseWatchNowButtonColorType;
  cta: string;
  ctaTarget: WatchButtonCtaTargetType;
  modalProps?: any;
  onClick?: () => void;
  href?: string;
  locale: string;
};

export default function LouiseWatchNowButton({
  textColor,
  cta,
  ctaTarget,
  href,
  onClick,
  locale,
  modalProps = {},
}: props) {
  const { openModal } = useModal();
  let needRedirect = true;
  let color, hoover;
  switch (textColor) {
    case 'blue':
      color = 'tw-text-blue-600';
      hoover = 'tw-text-gray-600';
      break;
    case 'white':
      color = 'tw-text-white';
      hoover = 'tw-text-blue-300';
      break;
    case 'gray':
      color = 'tw-text-gray-600';
      hoover = 'tw-text-blue-600';
      break;
    case 'black':
      color = 'tw-text-black';
      hoover = 'tw-text-gray-600';
      break;
    default:
      color = 'tw-text-blue-600';
      hoover = 'tw-text-gray-600';
  }

  const getDestination = () => {
    switch (ctaTarget) {
      case 'register':
      case 'login':
        return `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/${locale}/${ctaTarget}`;
      case 'youtube':
        return `https://www.youtube.com/@LouiseBot`;
      case 'plans':
        return `/${locale}/${ctaTarget}`;
      case 'roi-calculator':
      case 'discover-chatbot-ai':
      case 'discover-human-clone-link':
      case 'discover-videobot':
      case 'discover-chatbot-text':
      case 'discover-chatbot-type':
        needRedirect = false;
        return '/#';
      case 'other':
        return `/${locale}/${href}`;
      case 'external':
        return href;
      default:
        return `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/${locale}/register`;
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
      return;
    }

    switch (ctaTarget) {
      case 'discover-chatbot-type':
        openModal('DISCOVER_CHATBOT_TYPE', {
          ...modalProps,
          source: cta,
        });
        e.preventDefault();
        break;
      case 'discover-human-clone-link':
        openModal('DISCOVER_HUMAN_CLONE_LINK', {
          ...modalProps,
          source: cta,
        });
        e.preventDefault();
        break;
      case 'discover-chatbot-ai':
        openModal('DISCOVER_HUMAN_CLONE_LINK', {
          ...modalProps,
          source: cta,
        });
        e.preventDefault();
        break;
      case 'discover-videobot':
        openModal('DISCOVER_HUMAN_CLONE_LINK', {
          ...modalProps,
          source: cta,
        });
        e.preventDefault();
        break;
      case 'discover-chatbot-text':
        openModal('DISCOVER_HUMAN_CLONE_LINK', {
          ...modalProps,
          source: cta,
        });
        e.preventDefault();
        break;
      default:
        break;
    }
  };

  const destination = getDestination();
  return (
    <div className="tw-flex tw-items-center tw-justify-center">
      {needRedirect ? (
        <a
          href={destination}
          aria-label={cta}
          target={ctaTarget === 'external' ? '_blank' : '_self'}
          className={`tw-inline-flex tw-items-center tw-gap-2 ${color} hover:${hoover} tw-font-semibold tw-font-['Lexend'] tw-transition-colors tw-duration-300`}
        >
          <BiPlay className="tw-w-5 tw-h-5" />
          {cta}
        </a>
      ) : (
        <button
          onClick={handleClick}
          className={`tw-inline-flex tw-items-center tw-gap-2 ${color} hover:${hoover} tw-font-semibold tw-font-['Lexend'] tw-transition-colors tw-duration-300`}
        >
          <BiPlay className="tw-w-5 tw-h-5" />
          {cta}
        </button>
      )}
    </div>
  );
}
